import { render, staticRenderFns } from "./About.vue?vue&type=template&id=548cd56c&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"
import style0 from "./About.vue?vue&type=style&index=0&id=548cd56c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548cd56c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Timeline: require('/home/rohit/Documents/GitHub/aibuddha-website/components/Timeline.vue').default,TeamMember: require('/home/rohit/Documents/GitHub/aibuddha-website/components/TeamMember.vue').default,MidBanner: require('/home/rohit/Documents/GitHub/aibuddha-website/components/MidBanner.vue').default})
